import { combineReducers } from "redux";
import registerView from "./register-view";
import getMetrics from "./get-metrics";
import getIncrement from "./get-increment";
import getTimeSeries from "./get-time-series";
import getSubscriberViews from "./get-subscriber-views";

const reducer = combineReducers({
  registerView,
  getMetrics,
  getIncrement,
  getTimeSeries,
  getSubscriberViews,
});

export default reducer;

